import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-anchor-tag',
  template: `
    <div>
      <a class="buttonIcon grayIcon" [ngClass]="props.tagClass" (click)="onClick($event)">
        <ng-container *ngIf=props.icon><fa-icon [icon]="props.icon"></fa-icon></ng-container>
        {{ props.text }}
      </a>
    </div>
  `,
})
export class FormlyAnchorTagComponent extends FieldType {
  onClick($event: Event) {
    alert('xxx');
    if (this.props.onClick) {
      this.props.onClick($event);
    }
  }
}